import React, { useEffect, useRef, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { Dropdown } from 'primereact/dropdown';
import { BsExclamationCircleFill } from "react-icons/bs";

import AddModal from "components/Table/AddModal/AddModal";
import { useDispatch } from "react-redux";
import { getBuildingListLookup } from "redux/pages/Administration/Floor/floorSlice";
import { useAppSelector } from "redux/hooks";

interface Props {
  showModal: boolean;
  setShowModal: (state: boolean) => void;
  onAddFloor: (data: any) => void;
  selectedSite: any;
  fromDrawing?: any;
  uniqueBuildingId?: any;
}

type FormData = {
  uniqueSiteId: string;
  uniqueBuildingId: string;
  floorName: string;
};

export const AddFloors: React.FC<Props> = ({
  showModal = false,
  setShowModal = () => {},
  onAddFloor = () => {},
  selectedSite = [],
  fromDrawing= false,
  uniqueBuildingId = "",
}) => {
  const addForm: any = useRef();

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<FormData>({
    defaultValues: {
      uniqueSiteId:"",
      uniqueBuildingId: "",
      floorName: "",
    },
  });

  const buildngDetails = useAppSelector((state) => state.floor.buildingList);

  const [buildingLookup, setBuildingLookup] = useState<any>([]);

  const dispatch = useDispatch<any>();

  useEffect(() => {
    let body = {
      uniqueSiteId: selectedSite?.uniqueSiteId,
    };
    dispatch(getBuildingListLookup(selectedSite?.uniqueSiteId, body))
  }, [])

  useEffect(() => {
    if (buildngDetails) {
      let building: any = [];
      buildngDetails.map((item: any) => {
        building.push({uniqueBuildingId: item.uniqueBuildingId, buildingName: item.buildingName})
      })
      setBuildingLookup(building)
      if (fromDrawing) 
       setValue("uniqueBuildingId", uniqueBuildingId)
    }
  }, [buildngDetails])

  const formSubmitHandler = (data: any) => {
    addForm.current.requestSubmit();
  };

  const getFormErrorMessage = (name) => {
    return (
      errors[name] && (
        <span className="tooltip-text">
          <BsExclamationCircleFill />
          {errors[name].message}
        </span>
      )
    );
  };

  const onAddFormSubmit = (data: any) => {
    data.floorName = data.floorName.trim();
    onAddFloor && onAddFloor(data);
  };

  const onError = (errors: any, e: any) => {};

  return (
    <>
      <AddModal
        header="New Floor"
        showModal={showModal}
        isAdd={true}
        setShowModal={setShowModal}
        style={{ width: "35vw", height: "38vh" }}
        OnSaveClick={formSubmitHandler}
      >
        <form
          onSubmit={handleSubmit(onAddFormSubmit, onError)}
          ref={addForm}
        >
           <div className="row px-2">
                        <div className="field col-12 md:col-2 mb-0">
                            <span className="p-float-label text-container">
                                <label htmlFor="inputtext">Site</label>
                                <Controller
                                    name="uniqueSiteId"
                                    control={control}
                                    render={() => (
                                        <span className='text-value'>{selectedSite.siteName}</span>
                                    )} />
                            </span>
                        </div>
                    </div>
           <div className="row px-2 pt-2 pb-2">
                        <div className="field col-12 md:col-2 mb-0 pb-0">
                            <span className="p-float-label">
                                <Controller
                                    name="uniqueBuildingId"
                                    control={control}
                                    rules={{
                                        required: 'Building Name is required.'
                                    }}
                                    render={({ field, fieldState }) => (
                                        <Dropdown
                                            inputId="BuildingName"
                                            className={classNames('w-100 error-tooltip', { 'error': fieldState.invalid })}
                                            {...field}
                                            value={field.value}
                                            disabled={fromDrawing}
                                            onChange={(e) => field.onChange(e.value)}
                                            options={buildingLookup}
                                            optionLabel="buildingName"
                                            optionValue="uniqueBuildingId"
                                        />
                                    )} />
                                <label className='mandatory' htmlFor="dropdown">Building Name</label>
                                {getFormErrorMessage('uniqueBuildingId')}
                            </span>
                        </div>
                        
                    </div>

          <div className="row px-2 pb-2">
            <div className="field col-12 md:col-2 mb-0">
              <span className="p-float-label">
                <Controller
                  name="floorName"
                  control={control}
                  rules={{
                    required: "Floor Name is required.",
                  }}
                  render={({ field, fieldState }) => (
                    <InputText
                      id="name"
                      className={classNames("w-100 error-tooltip", {
                        error: fieldState.invalid,
                      })}
                      maxLength={100}
                      {...field}
                    />
                  )}
                />
                <label className="mandatory" htmlFor="inputtext">
                Floor Name
                </label>
                {getFormErrorMessage("floorName")}
              </span>
            </div>
          </div>
        </form>
      </AddModal>
    </>
  );
};

export default AddFloors;
